export const languageSwitcherStyles = {
  root:
    'group text-fg-secondary hover:text-fg-primary hover:bg-bg-subtle ' +
    'hidden h-11 w-11 items-center justify-center gap-1.5 rounded-md border border-border-subtle bg-bg-canvas p-0 min-[360px]:inline-flex sm:h-10 sm:w-auto sm:rounded-full sm:px-3 ' +
    'text-xs font-semibold uppercase tracking-wide ' +
    'transition-colors duration-fast ease-token ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
  icon: 'h-4 w-4 shrink-0 opacity-70 group-hover:opacity-100',
  // Fixed-width slot so the toggle doesn't jitter when label changes width.
  labelWrap:
    'relative hidden h-4 min-w-[26px] items-center justify-center overflow-hidden sm:inline-flex',
  // `key={current}` on the inner span forces a remount → re-runs the enter animation.
  label: 'inline-block leading-none [animation:lang-swap_220ms_cubic-bezier(0.16,1,0.3,1)_both]',
} as const;

// Tailwind v3 keyframes are configured via the preset; this fallback @keyframes
// gets injected at the consumer styles level. We use an inline animation name
// scoped to this component via the bracket-notation arbitrary value above.
if (typeof document !== 'undefined' && !document.getElementById('lang-swap-keyframes')) {
  const style = document.createElement('style');
  style.id = 'lang-swap-keyframes';
  style.textContent =
    '@keyframes lang-swap { 0% { opacity: 0; transform: translateY(6px); } 100% { opacity: 1; transform: translateY(0); } }';
  document.head.appendChild(style);
}
